import { connect } from "react-redux";

import { CandyDispatch } from "../../../../Engine/Core/Store/CandyReduxTypes";
import {
    getFufExpectedDemandFileName,
    prepareAndUploadFufFileAction,
    reloadForm,
    reloadFormInner,
    setFufAction,
    UploadedFileInfo,
} from "../../../../Engine/ActionCreators/FufUploadActionCreator";
import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { CustomFile } from "../../../../Helpers/file";

import { FufUploadModal } from "./FufUploadModal";

const mapStateToProps = (state: FullFormState) => ({
    currentGfv: state.settings.gfv,
    useServerSideFLangNormalization: state.settings.useServerSideFLangNormalization,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    setFuf: (driveUri: string): Promise<void> => dispatch(setFufAction(driveUri)),
    uploadFuf: (file: CustomFile | undefined, gfv: string): Promise<UploadedFileInfo> =>
        dispatch(prepareAndUploadFufFileAction(file, gfv)),
    reloadForm: async (useServerSideFLangNormalization?: boolean): Promise<void> => {
        if (useServerSideFLangNormalization) {
            await dispatch(reloadFormInner());
        } else {
            reloadForm();
        }
    },
    getFufExpectedDemandFileName: (): Promise<string | undefined> => dispatch(getFufExpectedDemandFileName),
});

export const FufUploadModalContainer = connect(mapStateToProps, mapDispatchToProps)(FufUploadModal);
